import request from '@/utils/http'
export function getPersonList () {
  return request({
    method: 'POST',
    url: '/rest/personnel/ajaxPersonnelList'
  })
}
// 校园/社会招聘
export function getRecruitmentList (data) {
  return request({
    method: 'POST',
    url: '/rest/personnel/ajaxRecruitmentList',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/recruit/index.js